import { PureComponent } from 'react'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import PropTypes from 'prop-types'
import { withTranslation } from 'react-i18next'

import validate from './validation'
import * as AppActions from '../../../../actions/app'
import * as ContentActions from '../../../../actions/content'
import { notify as notifyAction } from '../../../../actions/notifications'
import { MultiMediaForm } from '../../../../components/Screens'
import { mediaForm as mediaFormProps } from '../../../../types'
import { ObjectUtils, FileUtils } from '../../../../utils'
import { initialFormMedia } from '../../../../reducers/content/initialState'
import { attachMediaToPlaylist as actionAMP } from '../../../../actions/content/media'
import { withRouter } from 'react-router'

// Default start date
const defaultStartDateDate = new Date()
defaultStartDateDate.setHours(0)
defaultStartDateDate.setMinutes(0)
defaultStartDateDate.setSeconds(0)
const defaultStartDate = defaultStartDateDate.getTime()

// Default end date
const defaultEndDateDate = new Date()
defaultEndDateDate.setDate(new Date().getDate())
defaultEndDateDate.setHours(24)
defaultEndDateDate.setMinutes(0)
defaultEndDateDate.setSeconds(0)
const defaultEndDate = defaultEndDateDate.getTime() + 1000 * 60 * 60 * 24 * 30

class Media extends PureComponent {
    static propTypes = {
        clearUploadProgress: PropTypes.func.isRequired,
        editFormValue: PropTypes.func.isRequired,
        form: PropTypes.shape(mediaFormProps).isRequired,
        isOpen: PropTypes.bool,
        onClickCancel: PropTypes.func,
        onFinishSubmit: PropTypes.func,
        resetUpload: PropTypes.func.isRequired,
        saveUploadProgress: PropTypes.func.isRequired,
        selectedPlaylist: PropTypes.shape({}),
        t: PropTypes.func.isRequired,
        uploadMedia: PropTypes.func.isRequired,
        location: PropTypes.object.isRequired,
    }

    static defaultProps = {
        isOpen: false,
        onClickCancel: () => null,
        onFinishSubmit: () => null,
    }

    constructor(props) {
        super(props)

        this.state = {
            formErrors: {
                name: null,
                file: null,
                date_start: null,
                date_end: null,
            },
            progress: 0,
            isWorking: false,
            form: initialFormMedia,
            textPlaylist: null,
            selectedPlaylist: {
                key: null,
                value: '',
            },
        }

        this.onChangeFormFile = this.onChangeFormFile.bind(this)
        this.onChangeFormValue = this.onChangeFormValue.bind(this)
        this.onClickNullStartDate = this.onClickNullStartDate.bind(this)
        this.onClickNullEndDate = this.onClickNullEndDate.bind(this)
        this.onClickRemoveStartDate = this.onClickRemoveStartDate.bind(this)
        this.onClickRemoveEndDate = this.onClickRemoveEndDate.bind(this)
        this.onSubmit = this.onSubmit.bind(this)
    }

    componentDidMount() {
        this.setData(this.props)
    }
    componentWillUnmount() {
        this.props.onRef(undefined)
    }
    componentWillReceiveProps(nextProps) {
        this.setData(nextProps)
    }

    setData(props) {
        const { file, selectedPlaylist, location } = props
        let tempSelectedPlaylist = {
            key: null,
            value: '',
        }
        this.props.onRef(this)
        if (file) {
            this.onChangeFormFile({ target: { name: 'file', files: [file] } })
        }
        if (!location.pathname.includes('media') && !!selectedPlaylist && selectedPlaylist.id) {
            tempSelectedPlaylist.key = selectedPlaylist.id
            tempSelectedPlaylist.value = selectedPlaylist.name
        }
        this.setState({ progress: 0, selectedPlaylist: tempSelectedPlaylist })
    }

    loadData() {}

    // On Change any input value
    onChangeFormValue({ target: { name, value } }) {
        this.setState((preValue) => ({ form: { ...preValue.form, [name]: value } }))
    }

    onChangeFormFile({ target: { name, files } }) {
        const { form } = this.props
        this.setState((preValue) => ({ form: { ...preValue.form, [name]: files } }))
        const { name: formFileName } = form

        if (!formFileName && files.length) {
            const { name: fileName } = files[0]
            const fileWithoutExtension = FileUtils.getFileWithoutExtension(fileName)
            // editFormValue(`media`, { name: 'name', value: fileWithoutExtension })
            this.setState((preValue) => ({ form: { ...preValue.form, name: fileWithoutExtension } }))
        }
    }

    onClickNullStartDate() {
        this.onChangeFormValue({
            target: { name: 'date_start', value: defaultStartDate },
        })
    }

    onClickNullEndDate() {
        this.onChangeFormValue({
            target: { name: 'date_end', value: defaultEndDate },
        })
    }

    onClickRemoveStartDate() {
        this.onChangeFormValue({
            target: { name: 'date_start', value: null },
        })
    }

    onClickRemoveEndDate() {
        this.onChangeFormValue({
            target: { name: 'date_end', value: null },
        })
    }

    onProgress = (progress) => {
        this.setState({ progress })
    }

    onSubmit = async () => {
        if (!this.validate()) {
            return
        }

        this.setState({ isWorking: true })

        try {
            const { attachMediaToPlaylist, clearUploadProgress, onFinishSubmit, saveUploadProgress, uploadMedia, file: propFile } = this.props
            const { form, selectedPlaylist } = this.state

            const { file } = form

            const { size } = file[0]

            const media = { ...form, ...propFile, size }

            const saved = await uploadMedia(file[0], media, {
                onProgress: ({ progress }) => {
                    saveUploadProgress(progress, file[0].name)
                    this.setState({ progress })
                    this.setState({ currentfileName: file[0].name })
                },
            })

            clearUploadProgress()

            if (saved) {
                if (selectedPlaylist && selectedPlaylist.key) {
                    await attachMediaToPlaylist(saved.id, selectedPlaylist.key, false)
                }
                await onFinishSubmit(saved)
            } else {
                await onFinishSubmit(null)
            }
        } catch (e) {
            console.error(e)
            // TODO: Notify failure
        } finally {
            this.setState({ isWorking: false })
        }
    }

    buildOnchangeObject() {
        return {
            file: this.onChangeFormFile,
            name: this.onChangeFormValue,
            date_start: (value) => this.onChangeFormValue({ target: { name: 'date_start', value } }),
            date_end: (value) => this.onChangeFormValue({ target: { name: 'date_end', value } }),
            metadata: ({ videoHeight, videoLength, videoWidth }) => {
                this.onChangeFormValue({
                    target: { name: 'height', value: videoHeight },
                })
                this.onChangeFormValue({
                    target: { name: 'length', value: videoLength },
                })
                this.onChangeFormValue({
                    target: { name: 'width', value: videoWidth },
                })
            },
        }
    }

    get optionsPlaylists() {
        const { playlists } = this.props
        return playlists.map(({ id, name }) => ({ key: id, value: name }))
    }

    /**
     * Fetches new suggestions for the playlists input
     * @param {string} name Name written on the input
     */
    onTextChangePlaylists = (name) => {
        const { fetchPlaylists } = this.props
        const { textPlaylist } = this.state

        if (name !== textPlaylist) {
            fetchPlaylists(null, { name })
            this.setState({ textPlaylist: name })
        }
    }

    setPlaylistValue = (playlistId) => {
        const playlist = this.optionsPlaylists?.find((item) => item.key === playlistId)
        this.setState({ selectedPlaylist: playlist })
    }

    /**
     * Form Validation
     */
    validate() {
        // const { form } = this.props
        const { form } = this.state
        const formErrors = validate(form)
        this.setState({ formErrors })
        return ObjectUtils.isObjValuesEmpty(formErrors)
    }

    render() {
        const { isOpen, onClickCancel, t, onRemoveMedia, index, file } = this.props
        const { formErrors, progress, isWorking, form, selectedPlaylist, currentfileName } = this.state
        return (
            <MultiMediaForm
                errors={formErrors}
                isOpen={isOpen}
                isWorking={isWorking}
                onChangeForm={this.buildOnchangeObject()}
                onClickCancel={onClickCancel}
                onClickSubmit={this.onSubmit}
                onClickNullStartDate={this.onClickNullStartDate}
                onClickNullEndDate={this.onClickNullEndDate}
                onClickRemoveStartDate={this.onClickRemoveStartDate}
                onClickRemoveEndDate={this.onClickRemoveEndDate}
                onClickRemoveMedia={onRemoveMedia}
                progress={progress}
                values={form}
                t={t}
                index={index}
                onTextChangePlaylists={this.onTextChangePlaylists}
                optionsPlaylists={() => this.optionsPlaylists}
                selectedPlaylist={selectedPlaylist}
                setPlaylistValue={this.setPlaylistValue}
                fileName={file.name}
                currentfileName={currentfileName}
            />
        )
    }
}

const mapStateToProps = ({
    content: {
        form: { media: form },
        playlists,
        selected: { channels: selectedChannel, playlists: selectedPlaylist },
    },
    progress,
}) => ({
    form,
    playlists,
    selectedPlaylist,
    selectedChannel,
    progress,
})

const mapDispatchToProps = (dispatch) =>
    bindActionCreators(
        {
            ...ContentActions,
            notify: notifyAction,
            attachMediaToPlaylist: actionAMP,
            clearUploadProgress: AppActions.clearUploadProgress,
            saveUploadProgress: AppActions.saveUploadProgress,
        },
        dispatch
    )

export default connect(mapStateToProps, mapDispatchToProps)(withTranslation()(withRouter(Media)))
